import React from "react";
import UINode from "../uinode/UINode";

export default function ProductListPage({list}) {
  return <UINode node={list} />;
}